import { Document, Location, SubCategory, Category, Airport } from ".";
import { AdminUser } from "../redux/features/user/types";
import { ShippingOption } from "./ShipTypes";

export const FoundStatuses = {
  Open: 1,
  InProcess: 2,
  Prematched: 3,
  FinalMatch: 4,
  ReadyToShip: 5,
  Shipped: 6,
  Discarded: 7,
};

export type FoundReport = {
  id: string;
  itemNumber: string;
  itemDescription: string;
  remarks: string;
  foundBy: string;
  foundDate: string;
  offloadDate: string;
  status: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  airport: Airport;
  location: Location;
  category: Category;
  subCategory: SubCategory;
  documents: Document[];
  versionCount: number;
  isUrgent?: boolean;
  caseManagerName?: string;
  caseManager?: AdminUser;
  heightPrimaryValue?: number;
  heightPrimaryUnit?: string;
  heightSecondaryValue?: number;
  heightSecondaryUnit?: string;
  widthPrimaryValue?: number;
  widthPrimaryUnit?: string;
  widthSecondaryValue?: number;
  widthSecondaryUnit?: string;
  lengthPrimaryValue?: number;
  lengthPrimaryUnit?: string;
  lengthSecondaryValue?: number;
  lengthSecondaryUnit?: string;
  weightPrimaryValue?: number;
  weightPrimaryUnit?: string;
  weightSecondaryValue?: number;
  weightSecondaryUnit?: string;
  measurementType?: number;
  foundType?: number;
  description?: string;
  passengerEmail?: string;
  passengerEmail2?: string;
  passengerName?: string | null;
  passengerName2?: string | null;
  passengerPhone?: string | null;
  passengerPhone2?: string | null;
  shippingOptions?: ShippingOption[];
};

export enum FoundItemCardType {
  Found_Item = "found_item",
  Found_Item_Done = "found_item_done",
  Matched = "matched",
  Found_Item_PreMatch = "found_item_preMatch",
}

export type FoundItemType = 1 | 2;

export type UnitType = 1 | 2; // 1 for Imperial, 2 for Metric

export enum UnitTypeOptions {
  Imperial = 1,
  Metric = 2,
}

export enum FoundItemTypeOptions {
  FoundItem = 1,
  FoundLuggage = 2,
}

export interface DimensionValue {
  main?: number;
  sub?: number;
}

export interface Dimensions {
  length: DimensionValue;
  width: DimensionValue;
  height: DimensionValue;
  weight: DimensionValue;
}

export interface SingleDimension {
  length: number;
  width: number;
  height: number;
  weight: number;
}
